import { Component, ChangeDetectionStrategy, OnDestroy, OnInit, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { AddressInfo, getAthleteCredentialInfoPath, getAthleteInfoPath } from '@libs/entity-lib';
import { Store } from '@ngrx/store';
import { setAddressInfo } from '../../core/store/profile/profile.actions';
import { map, Subscription } from 'rxjs';

import { selectIsFormValid, selectAddressInfo, CrudAddressInfoComponent } from '@libs/address-lib';
import { selectCurrentAddressInfo } from '../../core/store/profile/profile.selectors';

import { CommonModule } from '@angular/common';
import { TranslationLibModule } from '@libs/translation';

import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

@Component({
  selector: 'crud-address-info-component',
  templateUrl: 'address-info.component.html',
  styleUrls: ['address-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    CommonModule,
    CrudAddressInfoComponent,
    TranslationLibModule,
  ],
  providers: [],
})
export class AddressInfoComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private router = inject(Router);

  form: FormGroup;

  isFormValid$ = this.store.select(selectIsFormValid);
  selectAddressInfo$ = this.store.select(selectAddressInfo);
  selectCurrentAddressInfo$ = this.store.select(selectCurrentAddressInfo);
  addressInfo = {} as AddressInfo;

  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.selectAddressInfo$
        .pipe(
          map((addressInfo) => {
            if (addressInfo) {
              this.addressInfo = addressInfo ?? ({} as AddressInfo);
              this.store.dispatch(setAddressInfo({ addressInfo: this.addressInfo }));
            }
          })
        )
        .subscribe()
    );
  }

  gotNextPage(isFormValid: boolean) {
    if (isFormValid) {
      this.store.dispatch(setAddressInfo({ addressInfo: this.addressInfo }));
      this.router.navigate([getAthleteCredentialInfoPath()]);
    }
  }

  getDefaultHref(): string {
    return getAthleteInfoPath();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
